import { InjectionToken } from "@angular/core";
import { IAppSettingsModalService } from "./i-app-settings-modal.service";

export const appSettingsModalServiceInjectionToken: InjectionToken<IAppSettingsModalService> = new InjectionToken<IAppSettingsModalService>("digital-signage.user-dashboard.dashboard-web.AppSettingsModalService");
